export enum TipoHaberes {
    Haber = 'HABER',
    Descuento = 'DESCUENTO',
    Ambos = 'Ambos',
}